import React from 'react'
import styles from './ElosSpotlight.module.css'
import { useLang } from '../../i18n/LanguageContext'

export default function ElosSpotlight() {
  const { T } = useLang()
  const e = T.elos

  return (
    <section className={styles.spotlight}>
      <div className={styles.left}>
        <div className={styles.leftInner}>
          <p className="section-label">{e.label}</p>
          <h2 className={`section-title section-title--light ${styles.title}`}>{e.title}</h2>
          <p className={styles.tagline}>{e.tagline}</p>

          <div className={styles.differentials}>
            {e.differentials.map((d) => (
              <div key={d.title} className={styles.diff}>
                <div className={styles.diffBar} aria-hidden="true" />
                <div>
                  <h3 className={styles.diffTitle}>{d.title}</h3>
                  <p className={styles.diffDesc}>{d.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <a href="https://elos.eqpitech.com.br" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
            {e.cta}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>

      <div className={styles.right}>
        <div className={styles.rightInner}>
          <p className={styles.rightLabel}>{e.journeyLabel}</p>
          <div className={styles.journey}>
            {e.journey.map((step, i) => (
              <div key={step.label} className={styles.step}>
                <div className={styles.stepNum}>0{i + 1}</div>
                <div className={styles.stepBody}>
                  <span className={styles.stepLabel}>{step.label}</span>
                  <span className={styles.stepDesc}>{step.desc}</span>
                </div>
                {i < e.journey.length - 1 && <div className={styles.stepConnector} aria-hidden="true" />}
              </div>
            ))}
          </div>

          <div className={styles.scoreNote}>
            <span className={styles.scoreTitle}>{e.scoreTitle}</span>
            <span className={styles.scoreDesc}>{e.scoreDesc}</span>
          </div>
        </div>
      </div>
    </section>
  )
}
